// extracted by mini-css-extract-plugin
export default {"card":"TextCard_card__VrE4S","card__title":"TextCard_card__title__K+90k","card__text":"TextCard_card__text__oZvwe"};